interface ChatBubbleProps {
  me: boolean;
  text: string;
  masked?: boolean;
  time: string;
}

export function ChatBubble({ me, text, masked, time }: ChatBubbleProps) {
  // Phase 11: 채팅 말풍선 - 나=brand-primary 10% 배경, 상대=surface-0
  // 좌/우 8px radius, 시간은 10px 회색 메타
  return (
    <div
      className={`max-w-[75%] rounded-2xl px-3 py-2 ${
        me
          ? "ml-auto bg-brand-primary/10"
          : "bg-surface-0 shadow-sm border border-line-subtle"
      }`}
    >
      <div className="text-[14px] leading-5 whitespace-pre-wrap text-ink-1">
        {text}
      </div>
      {masked && (
        <div className="text-[10px] text-red-500 mt-1">
          일부 정보가 안전을 위해 가려졌어요
        </div>
      )}
      <div className="text-[10px] text-ink-4 mt-0.5">{time}</div>
    </div>
  );
}
